import { ProductReelState, ProductReelType } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../store/rootReducer";
import { API_URL } from "config";

const initialState: ProductReelState = {
  reelProducts: [],
  highlightedProductsType: ProductReelType.BestSeller,
  isLoading: false,
};

const productsReel = createSlice({
  name: "productsSlice",
  initialState,
  reducers: {
    setReelProducts(state, action) {
      state.reelProducts = action.payload;
      state.isLoading = false;
    },
    setHighlightedProductsType(state, action) {
      state.highlightedProductsType = action.payload;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
  },
});
export const {
  setReelProducts,
  setHighlightedProductsType,
  setIsLoading,
} = productsReel.actions;

export const selectReelProducts = (state: RootState) =>
  state.productsReel.reelProducts;
export const selectHighlightedProductsType = (state: RootState) =>
  state.productsReel.highlightedProductsType;
export const selectIsLoading = (state: RootState) =>
  state.productsReel.isLoading;

export const fetchReelProducts = (productReelType: ProductReelType) => async (
  dispatch: any
) => {
  dispatch(setIsLoading(true));
  try {
    const favoriteProducts = await axios.get(
      `${API_URL}/products?${productReelType}=true&size=12`
    );
    dispatch(setReelProducts(favoriteProducts.data.data));
  } catch (error: any) {
    console.log(`Error in filterSlice all filters: ${error.message}`);
  }
};

export default productsReel.reducer;
